import { z } from 'zod';

/**
 * A string that must be present and not empty once trimmed, reporting
 * `message` for a value that is missing, empty or only spaces. Leading and
 * trailing spaces are trimmed from the parsed value, so a space typed by
 * accident is dropped rather than stored.
 */
export const requiredTrimmedString = (message: string) =>
  z.string(message).trim().min(1, message);
